__turbopack_context__.v({
  "carousel": "index-module-scss-module__dMFfCG__carousel",
  "carousel-section": "index-module-scss-module__dMFfCG__carousel-section",
  "carousel-section__title": "index-module-scss-module__dMFfCG__carousel-section__title",
});
